import { render, staticRenderFns } from "./DynamicChipField.vue?vue&type=template&id=4dbfdc74&scoped=true"
import script from "./DynamicChipField.vue?vue&type=script&lang=ts"
export * from "./DynamicChipField.vue?vue&type=script&lang=ts"
import style0 from "./DynamicChipField.vue?vue&type=style&index=0&id=4dbfdc74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbfdc74",
  null
  
)

export default component.exports